import { Outlet } from 'react-router-dom';

// Top-level layout. Phase 2 brings in OfflineIndicator + Toaster + global providers.
export default function RootLayout() {
  return <Outlet />;
}
